import EquipmentEditForm from "./equipment-edit-form";

export default EquipmentEditForm;